import { dataFetch } from '@lib/ggj-utils'

export default {
  // 升级预览
  upgradePre(params) {
    return dataFetch('/wholesale/api/upgrade/index', params, {
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      noGoLogin: true
    })
	},
	// 升级预览
	upgradePreV2(params) {
		return dataFetch('/wholesale/api/upgrade/index/v2', params, {
			method: 'post',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			},
			noGoLogin: true
		})
	},
  // 充值预览
  chargePre(params) {
    return dataFetch('/wholesale/api/deposit/chargePre', params, {
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
	},
	// 充值预览
	chargePreV2(params) {
    return dataFetch('/wholesale/api/deposit/chargePre/v2', params, {
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  // 校验填写推荐人
  checkRecommender(params) {
    return dataFetch('/wholesale/api/upgrade/checkRecommender', params, {
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  // 随机获取推荐人
  getAvailableRecommender(params) {
    return dataFetch('/wholesale/api/upgrade/availableRecommender', params, {
      method: 'get'
    })
  },
  // 充值提交
  chargeSubmit(params) {
    return dataFetch('/wholesale/api/deposit/chargeSubmit', params, {
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
	},
	// 充值提交
	chargeSubmitV2(params) {
		return dataFetch('/wholesale/api/deposit/chargeSubmit/v2', params, {
			method: 'post',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		})
	},
  // 获取支付参数
  payment(params) {
    return dataFetch('/cashier-desk/api/pay/payment', params, {
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
   //判断是否要进入安全升级页面
   goToSafeUp(params) {
    return dataFetch('/wholesale/api/deposit/charge/intercept', params, {
      'method': 'get'
    })
  },
}

